function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 3.175C23.895 4.253 27.183 10.31 27.939 21 29.657 21 31 22.343 31 24a3 3 0 0 1-3 3h-7.1a5.002 5.002 0 0 1-9.8 0H4a3 3 0 1 1 0-6C4.811 10.31 8.104 4.253 14 3.175V3a2 2 0 1 1 4 0v.175zM18.83 27h-5.66a3.001 3.001 0 0 0 5.66 0zM6.065 21H22v2H4a1 1 0 1 0 0 2h24a1 1 0 1 0 0-2h-1a1 1 0 0 1-.998-.945C25.36 10.517 21.989 5 16 5c-5.803 0-9.149 5.18-9.934 16z"
});

var SvgNotification = function SvgNotification(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "f9a29ecfac786a05d328abddf5971513.svg";
export { SvgNotification as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/notification.svg
// module id = null
// module chunks = 